import { HelmetDexteel } from "@dexteel/mesf-core";
import { TableWaterAllocations } from "./components/TableWaterAllocations";

export const WaterAllocationsPage = () => (
	<>
		<HelmetDexteel title="Water Allocations" />
		<TableWaterAllocations />
	</>
);
